'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CardFooter", {
    enumerable: true,
    get: function() {
        return CardFooter;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCardFooter = require("./useCardFooter");
const _renderCardFooter = require("./renderCardFooter");
const _useCardFooterStylesstyles = require("./useCardFooterStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CardFooter = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCardFooter.useCardFooter_unstable)(props, ref);
    (0, _useCardFooterStylesstyles.useCardFooterStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCardFooterStyles_unstable')(state);
    return (0, _renderCardFooter.renderCardFooter_unstable)(state);
});
CardFooter.displayName = 'CardFooter';
